// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/tabs-standalone/tabs-standalone.component.scss
// module id = 558
// module chunks = 0